// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 85 ? "17665a9f" : chunkId) + "." + {"85":"ab8a351e33546c0a","268":"c9d32928085e554e","647":"b6817e80d0ac9ffa"}[chunkId] + ".js";
};